import { intervalToDuration } from 'date-fns';
import { padStart } from 'lodash';

export const padded = (timePart: number | undefined) => padStart(String(timePart ?? 0), 2, '0');

// TODO: Recording. Возможно вынести в toolkit
export const formatSecondsToHumanReadableTimestamp = (secondsAmount: number) => {
    const { hours, minutes, seconds } = intervalToDuration({
        start: 0,
        end: secondsAmount * 1000,
    });

    return `${padded(hours)}:${padded(minutes)}:${padded(seconds)}`;
};

export const getTimeZone = () => {
    const formatter = new Intl.DateTimeFormat('ru-RU', {
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        timeZoneName: 'short',
    });
    const dateParts = formatter.formatToParts(new Date());
    const timeZone = dateParts.find(({ type }) => type === 'timeZoneName')?.value;
    return timeZone || 'GMT+3';
};
